import type { TypeTableColumn } from '@thefarmersfront/kitchen';

import type { TypeDeliveryAgencyOrdersUploadResult } from '~/types/delivery-agency.types';

type TypeInsufficientAddress = NonNullable<TypeDeliveryAgencyOrdersUploadResult['insufficientAddresses']>[number];

const getDeliveryAgencyOrderInsufficientAddressColumnDefs = () => {
  const columnDefs: TypeTableColumn<TypeInsufficientAddress>[] = [
    {
      id: 'no',
      header: 'No',
      cell: ({ row }) => row.index + 1,
      size: 72,
    },
    {
      accessorKey: 'rowNums',
      header: '확인 필요 대상',
      size: 120,
      cell: ({ row }) => row.original.rowNums.map((num) => `${num}행`).join(', '),
      meta: { overflow: 'wrap' },
    },
    {
      accessorKey: 'address',
      header: '입력한 주소',
      meta: { flex: true, overflow: 'wrap' },
    },
  ];

  return { columnDefs };
};

export default getDeliveryAgencyOrderInsufficientAddressColumnDefs;
